export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_Hk.0b24fdd3.webp";